import React, { useState } from 'react';
import { formatDate } from 'utils/commonFunctions';

const Dropdown = ({
  label,
  list,
  value,
  icon,
  handleClick,
  language,
  ddExtraCls,
  displayKeyName,
  drpDate,
  isDateShow,
  getMatchDeadline
}) => {
  const [isActive, setIsActive] = useState(true);
  return (
    <>
      <div
        className={`si-dropdown ${!isActive ? 'si-active' : ''} ${ddExtraCls ? ddExtraCls : ''}`}
      >
        {label ? <div className='si-dropdown__lbl'>{label}</div> : ''}
        <div className='si-dropdown__box'>
          <div
            className='si-dropdown__value'
            onClick={() => {
              setIsActive(!isActive);
            }}
          >
            {icon ? <i className={icon}></i> : ''}
            <span dangerouslySetInnerHTML={{ __html: value }}></span>
            {isDateShow ? <em>{drpDate}</em> : ''}
            {/* {value} */}
            <div className='si-value__icon'>
              {!isActive ? (
                <i className='lms-chevron-up'></i>
              ) : (
                <i className='lms-chevron-down'></i>
              )}
            </div>
          </div>
          {!isActive ? (
            <div className='si-dropdown__list'>
              <ul>
                {list?.map((item, index) => (
                  <li
                    key={index}
                    className={value === item?.[displayKeyName] ? 'si-active' : ''}
                    onClick={() => {
                      handleClick(item);
                      setIsActive(!isActive);
                    }}
                  >
                    <span>{item?.[displayKeyName]}</span>{' '}
                    {getMatchDeadline(item.name) ? formatDate(getMatchDeadline(item.name)) : 'N/A'}
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    </>
  );
};

export default Dropdown;
